export default __webpack_public_path__ + "static/media/Cobertura incluida en tu Plan_asistencia_viajero_P_NOVO.8434edd3.pdf";